import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { FaqLatestUpdates, FaqSeeAll, Href } from "../../../Constant";
import { LATEST_FAQ_DATA } from "../../../Data/Faq";
import { H3, P } from "../../../AbstractElements";
import { Link } from "react-router-dom";

const LatestUpdate = () => {
  return (
    <Col lg="12">
      <Card>
        <CardHeader className="faq-header card-no-border pb-0">
          <H3 className="d-inline-block">{FaqLatestUpdates}</H3>
          <span className="pull-right d-inline-block">{FaqSeeAll}</span>
        </CardHeader>
        <CardBody className="faq-body">
          {LATEST_FAQ_DATA.map((item, i) => (
            <div className="d-flex updates-faq-main" key={i}>
              <div className="updates-faq">{item.iconClass}</div>
              <div className="flex-grow-1 updates-bottom-time">
                <P>{item.name} <Link to={Href}>{item.val}</Link> {item.title}</P>
                <P>{item.time}</P>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default LatestUpdate;
